import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import {change, Field} from 'redux-form';
import {compose} from 'recompose';
import {connect} from 'react-redux';
import {padDateString} from '../shared/functions';
import {renderDateInput} from '../shared/formFunctions';
import {viewStyles} from '../shared/styles-view';

/**
 * A Text Input that verifies the uniqueness of its value.
 *
 */
class FormattedDateTextInput extends Component {
    constructor(props) {
        super(props);
        let value = (props && props.record && props.record[props.source])
            ? props.record[props.source]
            : undefined;

        if (props.dependsOnValue && props.dependsOnValue[props.source]) {
            value = props.dependsOnValue[props.source];
        }
        this.state = {
            inputValue: value,
            sourceValue: null,
        };

        this.handleInputChange = this.handleInputChange.bind(this);
    }

    /**
     * Handle input field change event
     *
     * @param event
     * @param index
     * @param value
     */
    handleInputChange(event, index, value) {
        this.setState({
            inputValue: index,
        });
        this.props.dispatch(change(this.props.formName, this.props.source, index));
    }

    render() {
        const {
            allowInputValue,
            isRequired,
            label,
            maxDate,
            minDate,
            placeholder,
            source,
            style
        } = this.props;

        const {inputValue} = this.state;

        const min =
            minDate && typeof minDate === 'object'
                ? minDate.getFullYear() +
                '-' +
                padDateString(minDate.getMonth() + 1) +
                '-' +
                padDateString(minDate.getDate())
                : null;

        const max =
            maxDate && typeof maxDate === 'object'
                ? maxDate.getFullYear() +
                '-' +
                padDateString(maxDate.getMonth() + 1) +
                '-' +
                padDateString(maxDate.getDate())
                : null;

        return (
            <Fragment>
                <label
                    htmlFor={`input-date-${source}`}
                    style={viewStyles.calendarInputLabel}
                >
                    {label}
                </label>

                <Field
                    id={`input-date-${source}`}
                    key={`input-date-${source}`}
                    component={renderDateInput}
                    name={source}
                    placeholder={placeholder}
                    maxDate={max}
                    minDate={min}
                    inputValue={(allowInputValue && inputValue) ? inputValue : undefined}
                    onChange={this.handleInputChange}
                    style={style}
                    required={isRequired}
                />
            </Fragment>
        );
    }
}

FormattedDateTextInput.propTypes = {
    addField: PropTypes.bool,
    allowInputValue: PropTypes.bool,
    formName: PropTypes.string,
    formType: PropTypes.string,
    isRequired: PropTypes.bool,
    label: PropTypes.string,
    maxDate: PropTypes.instanceOf(Date),
    minDate: PropTypes.instanceOf(Date),
    placeholder: PropTypes.string,
    source: PropTypes.string.isRequired,
    style: PropTypes.any,
};

FormattedDateTextInput.defaultProps = {
    addField: true,
    allowInputValue: true,
    formName: 'filterForm',
    formType: 'edit',
    isRequired: true,
    placeholder: '',
    style: {},
};

const enhance = compose(connect());

export default enhance(FormattedDateTextInput);



// WEBPACK FOOTER //
// ./src/Fuse/components/FormattedDateTextInput.js